import React, { useEffect } from "react";
import { BannerWrapper } from "./Styled";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ContactButton } from "../../styled/CustomElements";
import {
  AddOne,
  AddThree,
  AddTwo,
  BuildingsTwo,
  Person,
  RightArrow,
} from "../../styled/AllImages";
import { scroller } from "react-scroll";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, HeadingStyled, MainHeading } from "../../styled/Elements";
import { InputStyled } from "../../styled/Styled";
import { useNavigate } from "react-router-dom";

const Banner = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();

  const renderStyledText = (text) => {
    return text.replace(
      /<color>(.*?)<\/color>/g,
      '<span style="color: var(--themeColorSecondary);">$1</span>'
    );
  };

  const secureTitle = renderStyledText(t("falhub_title"));
  const secureText = renderStyledText(t("description"));

  const sliderSettings = {
    infinite: true,
    speed: 1000,
    fade: true,
    autoplay: true,
    autoplaySpeed: 4000,
    vertical: true,
    arrows: false,
  };

  useEffect(() => {
    const updateVisualsOnHeight = () => {
      const windowHeight = window.innerHeight;

      let sliderScale = "1";
      let topMargin = "20px";
      let personWidth = "40rem";
      let personScale = "1";
      let personLeft = "30%";
      let bannerContentMarBot = "18rem";
      let bannerContentWidth = "";
      let holyLight = "";
      let buildingsHeight = "60vh";

      if (windowHeight < 500) {
        sliderScale = "0.6";
        topMargin = "10px";
        personScale = "0.68";
        personLeft = "25%";
        bannerContentMarBot = "12rem";
        bannerContentWidth = "100%";
        holyLight = "none";
      } else if (windowHeight < 530) {
        sliderScale = "0.6";
        topMargin = "10px";
        personScale = "0.68";
        personLeft = "25%";
        bannerContentMarBot = "12rem";
        bannerContentWidth = "100%";
      } else if (windowHeight < 560) {
        sliderScale = "0.6";
        personScale = "0.6";
        bannerContentMarBot = "12rem";
        bannerContentWidth = "50%";
        buildingsHeight = "50vh";
      } else if (windowHeight < 600) {
        sliderScale = "0.72";
        topMargin = "20px";
        personScale = "0.7";
        personLeft = "25%";
        bannerContentMarBot = "16rem";
        buildingsHeight = "60vh";
      } else if (windowHeight < 700) {
        sliderScale = "0.8";
        topMargin = "20px";
        personScale = "0.8";
      } else if (windowHeight < 800) {
        sliderScale = "1";
        topMargin = "20px";
      } else {
        sliderScale = "1";
        topMargin = "20px";
      }

      // Person scale
      const personBottom = windowHeight < 700 ? "-3.7rem" : "-1rem";

      // Set CSS vars
      document.documentElement.style.setProperty(
        "--sliderTopMargin",
        topMargin
      );
      document.documentElement.style.setProperty("--sliderScale", sliderScale);
      document.documentElement.style.setProperty("--personScale", personScale);
      document.documentElement.style.setProperty(
        "--personBottom",
        personBottom
      );
      document.documentElement.style.setProperty("--personWidth", personWidth);
      document.documentElement.style.setProperty("--personLeft", personLeft);
      document.documentElement.style.setProperty(
        "--bannerContentMarBot",
        bannerContentMarBot
      );
      document.documentElement.style.setProperty(
        "--bannerContentWidth",
        bannerContentWidth
      );
      document.documentElement.style.setProperty("--holyLight", holyLight);
      document.documentElement.style.setProperty(
        "--buildingsHeight",
        buildingsHeight
      );
    };

    updateVisualsOnHeight();
    window.addEventListener("resize", updateVisualsOnHeight);

    return () => window.removeEventListener("resize", updateVisualsOnHeight);
  }, []);

  return (
    <BannerWrapper className="banner" id="home" lang={language}>
      <Row>
        <Col className="position-relative">
          <Box className="header-main">
            <Container className="banner-container">
              <Box className="bannerContentWrapper">
                <Box className="banner-content col-md-12 col-lg-6">
                  <MainHeading
                    lang={language}
                    className="main-heading caption-sub-heading lh-1"
                    color="var(--themeColor)"
                    size="43.71px"
                    weight="950"
                    dangerouslySetInnerHTML={{ __html: secureTitle }}
                  />
                  <MainHeading
                    lang={language}
                    className="main-heading caption-sub-heading lh-1"
                    color="var(--themeColorSecondary)"
                    size="43.71px"
                    weight="950"
                    dangerouslySetInnerHTML={{ __html: secureText }}
                  />
                  <Box className="cta-wrapper mt-3">
                    <InputStyled
                      style={{ cursor: "pointer" }}
                      lang={language}
                      color="var(--text)"
                      name="name"
                      placeholder="falhub.com/yourname"
                      onMouseDown={(e) => {
                        e.preventDefault(); // prevent focus
                      }}
                      onClick={() => navigate("/signup")}
                    />
                    <ContactButton
                      lang={language}
                      iconSize="12px"
                      iconAfter={RightArrow}
                      label={t("cta")}
                      bg="var(--themeColorSecondary)"
                      color="var(--white)"
                      clName={"signin-btn"}
                      onClick={() => navigate("/signup")}
                    />
                    {/* <Box>
                    </Box> */}
                  </Box>
                </Box>

                <Box className="px-lg-5">
                  <Slider className="slider-wrapper" {...sliderSettings}>
                    <div className="slider-image-wrapper">
                      <img
                        className="slider-image"
                        src={AddOne}
                        alt="Slide 1"
                      />
                    </div>
                    <div className="slider-image-wrapper">
                      <img
                        className="slider-image"
                        src={AddTwo}
                        alt="Slide 2"
                      />
                    </div>
                    <div className="slider-image-wrapper">
                      <img
                        className="slider-image"
                        src={AddThree}
                        alt="Slide 3"
                      />
                    </div>
                  </Slider>
                </Box>
              </Box>
            </Container>
          </Box>
        </Col>
      </Row>
      <img src={BuildingsTwo} className="buildings" alt="buildings" />
      <Person className="person" />
      <div className="holyLight"></div>
    </BannerWrapper>
  );
};

export default Banner;
